import { Breadcrumb, CardSkeletonLoader } from '@/components/atoms';
import { PageHeader, SaveCancelFooter } from '@/components/molecules';
import { PageContainer } from '@/components/organisms';
import ReviewBulkPoint from '@/containers/ReviewBulkPointModifiers/ReviewBulkPoint'
import useReviewBulkPointModifier from '@/containers/ReviewBulkPointModifiers/ReviewBulkPointModifier-hooks';

const ReviewBulkPointModifiers = () => {
  const { handleCancel, handlePublish, handleDraft, id, loading } = useReviewBulkPointModifier()
  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: '',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },
            {
              href: '',
              label: 'Point Modifiers',
            },
          ],
        }}
        id={'cbpm_bradcrumb'}
      />
      <PageHeader title="Create Bulk Point Modifiers" />
      {loading? <PageContainer>
      <CardSkeletonLoader> </CardSkeletonLoader>
      </PageContainer>: 
      <ReviewBulkPoint bulkPointModifierId={id} />
      }
      {!id ? (
        <SaveCancelFooter
          isReview={true}
          handleCancel={handleCancel}
          nextAction={handlePublish}
          draftAction={handleDraft}
        />
      ) : null}
    </>
  )
}

export default ReviewBulkPointModifiers;